import React, { Component, Fragment } from 'react';
import PropTypes from 'prop-types';

export default class Breakpoint extends Component {
  static propTypes = {
    children: PropTypes.func.isRequired,
    test: PropTypes.shape({
      target: PropTypes.oneOf(['width', 'height', 'widthHeight']),
      value: PropTypes.oneOfType([
        PropTypes.number,
        PropTypes.shape({
          width: PropTypes.number,
          height: PropTypes.number,
        }),
      ]),
      targetIs: PropTypes.oneOf(['gt', 'lt']).isRequired,
    }),
  };

  static defaultProps = {
    test: {
      target: 'widthHeight',
      value: {
        width: 0,
        height: 0,
      },
      targetIs: 'gt',
    },
  };

  state = {
    width: 0,
    height: 0,
  };

  componentDidMount() {
    const { width, height } = this.state;
    if (width === 0 && height === 0) {
      this.handleWindowSizeChange();
    }
    window.addEventListener('resize', this.handleWindowSizeChange);
  }

  componentWillUnmount() {
    window.removeEventListener('resize', this.handleWindowSizeChange);
  }

  handleWindowSizeChange = () => {
    this.setState({ width: window.innerWidth, height: window.innerHeight });
  };

  check = targetValue => (value, targetIs) => {
    if (targetIs === 'gt') {
      return targetValue >= value;
    }

    return targetValue <= value;
  };

  testTarget = () => {
    const { width, height } = this.state;
    const { test } = this.props;
    const checkWidth = this.check(width);
    const checkHeight = this.check(height);

    if (test.target === 'width') {
      return checkWidth(test.value, test.targetIs);
    }

    if (test.target === 'height') {
      return checkHeight(test.value, test.targetIs);
    }
    if (test.target === 'widthHeight') {
      return checkWidth(test.value.width, test.targetIs) && checkHeight(test.value.height, test.targetIs);
    }

    return false;
  };

  render() {
    const { children } = this.props;
    const show = this.testTarget();
    return <Fragment>{children(show)}</Fragment>;
  }
}
